import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Popover from './Popover';

// Colors used to generate default avatars
const AVATAR_DEFAULT_COLORS = [
  '#2d84bd',
  '#35434d',
  '#3dbcb1',
  '#8e24aa',
  '#a61e24',
  '#c8bea3',
  '#efa72f',
  '#f26c4f',
];

// Color used to as default avatar for new resources
const NEW_RESOURCE_COLOR = '#5c6267';

export default class Avatar extends Component {
  static propTypes = {
    className: PropTypes.string,
    href: PropTypes.string,
    name: PropTypes.string,
    showInitials: PropTypes.bool,
    src: PropTypes.string,
    type: PropTypes.string,
    htmlAttrs: PropTypes.object,
    style: PropTypes.object,
    headline: PropTypes.string,
    hover: PropTypes.bool,
  }

  static defaultProps = {
    className: null,
    href: null,
    showInitials: true,
    src: null,
    type: 'user',
    headline: null,
    hover: false,
    htmlAttrs: {},
    style: {},
    name: null,
  }

  sumChars(str) {
    let sum = 0;
    for (let i = 0; i < str.length; i += 1) {
      sum += str.charCodeAt(i);
    }
    return sum;
  }

  renderWithHover = (attrs, content) => {
    const triggerElement = (this.props.href ? (
      this.renderWithLink(attrs, content)
    ) : (
      this.renderWithoutLink(attrs, content)
    ));

    const popoverProps = Object.assign({}, this.props, {hover: false, className: "u-w-12 u-h-12", htmlAttrs: {}, style: {}});

    return (
      <Popover
        popoverClass="sm:u-p-2"
        triggerClass={this.props.className}
        hover
        icon={false}
        element={triggerElement}
      >
        <div className="u-flex u-items-center">
          <Avatar {...popoverProps} />
          <div className="u-ml-2">
            <div className="u-font-bold u-text-lg">{this.props.name}</div>
            <div className="u-text-sm">{this.props.headline}</div>
          </div>
        </div>
      </Popover>
    );
  }

  renderWithLink = (attrs, content) => {
    return <a {...attrs} {...this.props.htmlAttrs} href={this.props.href}>{ content }</a>;
  }

  renderWithoutLink = (attrs, content) => {
    return <div {...attrs} {...this.props.htmlAttrs}>{ content }</div>;
  }

  render() {
    let bgdColor;
    let initialOrIcon;
    if (this.props.name) {
      bgdColor = AVATAR_DEFAULT_COLORS[this.sumChars(this.props.name) % AVATAR_DEFAULT_COLORS.length];
      initialOrIcon = this.props.name[0];
    } else {
      // New resource state
      bgdColor = NEW_RESOURCE_COLOR;
      initialOrIcon = (
        <i className={`Icon Icon-${this.props.type}`} />
      );
    }
    const style = this.props.src ? { backgroundImage: `url(${this.props.src})` } : { background: bgdColor };
    const attrs = {
      className: `${this.props.className} Avatar Avatar--${this.props.type} u-flex-shrink-0`,
      draggable: false,
      style: Object.assign({}, this.props.style, style),
    };
    const content = !this.props.src && this.props.showInitials && <div className="Avatar-initials">{initialOrIcon}</div>;

    if (this.props.hover) {
      return this.renderWithHover(attrs, content);
    }

    if (this.props.href) {
      return this.renderWithLink(attrs, content);
    }
    return this.renderWithoutLink(attrs, content);
  }
}
